// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import TemplateSelectorController from "./template_selector_controller"
application.register("template-selector", TemplateSelectorController)

import TableNumberController from "./table_number_controller"
application.register("table-number", TableNumberController)

import MenuItemNameController from "./menu_item_name_controller"
application.register("menu-item-name", MenuItemNameController)

import ReceiptQuantityController from "./receipt_quantity_controller"
application.register("receipt-quantity", ReceiptQuantityController)

import MenuImageGeneratorController from "./menu_image_generator_controller"
application.register("menu-image-generator", MenuImageGeneratorController)

import MenuScaleController from "./menu_scale_controller"
application.register("menu-scale", MenuScaleController)

import PreviewViewerController from "./preview_viewer_controller"
application.register("preview-viewer", PreviewViewerController)

import PreviewLoaderController from "./preview_loader_controller"
application.register("preview-loader", PreviewLoaderController)

import MenuLoaderController from "./menu_loader_controller"
application.register("menu-loader", MenuLoaderController)

import OnboardingModalController from "./onboarding_modal_controller"
application.register("onboarding-modal", OnboardingModalController)

import MenuModalController from "./menu_modal_controller"
application.register("menu-modal", MenuModalController)

import AgreementValidationController from "./agreement_validation_controller"
application.register("agreement-validation", AgreementValidationController)

import RandomMenuNameController from "./random_menu_name_controller"
application.register("random-menu-name", RandomMenuNameController)

import MenuNameValidationController from "./menu_name_validation_controller"
application.register("menu-name-validation", MenuNameValidationController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import SignageController from "./signage_controller"
application.register("signage", SignageController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

export { application };
